import { render, staticRenderFns } from "./mbHeader.vue?vue&type=template&id=8c8b6980&"
import script from "./mbHeader.vue?vue&type=script&lang=js&"
export * from "./mbHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports